module.exports = __webpack_public_path__ + "img/ins.1234ed02.png";